import React, { useEffect } from "react";

/* -------- packages -------- */
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from "react-redux";
import { Container } from "reactstrap";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
/* -------- ------- -------- */

/* -------- intern functions -------- */
import { fetchAgenciesRequest, deleteAgencyRequest, openEditPageAgency, clearAgencyErrors, clearAgencySuccess } from "../../store/actions";
/* -------- ------- -------- */

/* -------- components -------- */
import TableContainer from "../../components/ui/List/TableContainer";
import Breadcrumb from "../../components/ui/Breadcrumbs";
import { getErrorFromResponse } from "../../utils/utils";
import ErrorHandler from "../../components/ui/Error/ErrorHandler";
/* -------- ------- -------- */

export default function Agencies () {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  
  const parameters = useSelector(state => state.Parameters);
  document.title = `${t('agencies')} | ${parameters.appName}`; //meta title

  const {agencies, agencyAdded, errorAgency} = useSelector(state => state.Agencies);


  // Configuration des colonnes
  const columnConfig = [
    { key: 'id', type: 'text' },
    { key: 'lib', type: 'text' },
    { key: 'createdAt', type: 'date' },
    { key: 'updatedAt', type: 'date' },
  ];

  useEffect(() => {
    dispatch(fetchAgenciesRequest());
  }, []);

  ErrorHandler(errorAgency, clearAgencyErrors);

  useEffect(() => {
    if (agencyAdded) {
      toast.success(t('dataSaved'));
      dispatch(clearAgencySuccess());
    }
  }, [agencyAdded]);

  return (

      <div className="page-content">
        <Container fluid>
          <Breadcrumb breadcrumbItem={t("agencies")}/>
          
          <TableContainer
            columnConfig={columnConfig}
            filterConfig={[]}
            data={agencies}
            tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
            theadClass="table-light"
            paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
            pagination="pagination"
            divClassName="table-responsive"
            isBordered={true}
            isPagination={true}
            isGlobalFilter={true}
            buttonClass="btn btn-primary btn-rounded waves-effect waves-light addContact-modal mb-2"
            buttonName="newAgency"
            prefListName="agency"
            totalKpi={{label: 'numberOfAgencies', icon: 'mdi mdi-office-building-marker'}}
            isAddButton={true}
            isNewButton={false}
            linkToNew={'/agencies/new'}
            editFunction={openEditPageAgency} 
            deleteFunction={deleteAgencyRequest}
            defaultSortColumn={'lib'}
            defaultSortDirection={'asc'}
          />
        </Container>
        <ToastContainer />
      </div>

  );
};

